import { Component, createRef } from 'react'
import { Modal, Row, Col, FormControl, FormLabel, Form } from 'react-bootstrap'
import Button from 'react-bootstrap-button-loader'
import moment from "moment"
import DatePicker from "react-datepicker"
import Select from 'react-select'
import * as ajax from '../Utilities/ajax'
import { extname } from "path"

export default class NewMacroEco extends Component<any> {
  state = {
    loading: false,
    data: {
      id: undefined,
      date: undefined,
      title: undefined,
      researchType: undefined,
      author: undefined,
      fileName: undefined,
    },
    file: undefined,
  }
  fileRef = createRef<HTMLInputElement>()

  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open) {
      const data = nextProps.open.data || {}
      if (!data.date) {
        data.date = moment().format("YYYY-MM-DD")
      }
      this.setState({
        loading: false,
        data: data,
        file: undefined,
      })
    }
  }

  onModalConfirm = async () => {
    const { onClose } = this.props
    const { data, file } = this.state

    this.setState({ loading: true })

    //? Create Entity
    let result
    if (!data.id) {
      result = await ajax.post(
        "/macroeco",
        data,
      )
    }
    else {
      result = await ajax.put(
        "/macroeco",
        data,
      )
    }

    //? Upload File
    if (file) {
      const _formData = new FormData()
      _formData.append(`sampleFile[0]`, file, data.fileName)
      await ajax.postFormData(
        `/macroeco/upload?id=${result.data.id}`,
        _formData,
      )
    }

    this.setState({ loading: false })
    onClose(true)
  }

  handleSelectFile = (file: any) => {
    const { data } = this.state
    if (file && extname(file.name).toLowerCase() === ".pdf") {
      this.setState({
        file: file,
        data: {
          ...data,
          fileName: data.fileName || `${moment().format("YYYYMMDDHHmmss")}${extname(file.name)}`,
        },
      })
    }
  }

  render() {
    const { onClose } = this.props
    const { loading, data, file } = this.state
    const { id, date, title, researchType, author, fileName } = data

    return (
      <Modal show={this.props.open.show}>
        {/* Header */}
        <Modal.Header>
          <Modal.Title>{`${!id ? "Create New" : "Modify"} Macroeconomics`}</Modal.Title>
        </Modal.Header>

        {/* Body */}
        <Modal.Body>
          <Form.File id="formcheck-api-custom" custom style={{ display: "none" }} >
            <Form.File.Input isValid={true} ref={this.fileRef} accept=".pdf" onChange={e => this.handleSelectFile(e.target.files[0])} />
          </Form.File>

          {/* Upload File */}
          <Row>
            <Col xs={5} sm={4}><FormLabel style={{ marginTop: '6px' }}>Research File</FormLabel></Col>
            <Col xs={5} sm={7} style={{ display: "flex", alignItems: "flex-end" }} >
              <Button variant="outline-secondary"
                style={{ marginTop: 5, marginBottom: "auto", paddingTop: 2, paddingBottom: 2 }}
                onClick={() => this.fileRef.current.click()}
                disabled={loading}
              >
                Browse
              </Button>
              {(file?.name || fileName) && (
                <div style={{ display: "inline-block", marginLeft: '5px', wordBreak: "break-word" }}>
                  {file?.name || fileName}
                </div>
              )}
            </Col>
          </Row>

          {/* Date */}
          <Row>
            <Col xs={5} sm={4}><FormLabel style={{ marginTop: 6 }}>Date</FormLabel></Col>
            <Col xs={5} sm={7} style={{ marginTop: 6 }}>
              <DatePicker
                dateFormat="dd/MM/yyyy"
                selected={moment(date).toDate()}
                onChange={(value) => this.setState({ data: { ...data, date: moment(value).format("YYYY-MM-DD") } })}
                disabled={loading}
              />
            </Col>
          </Row>

          {/* Title */}
          <Row>
            <Col xs={12} sm={4}><FormLabel style={{ marginTop: 6 }}>Title</FormLabel></Col>
            <Col xs={12} sm={7}>
              <FormControl type="text" name="title" placeholder="Title" style={{ marginTop: 5 }} value={title || ""}
                onChange={(e) => this.setState({ data: { ...data, title: e.target.value } })}
                disabled={loading}
              />
            </Col>
          </Row>

          {/* Research Type */}
          <Row>
            <Col xs={12} sm={4}><FormLabel style={{ marginTop: 6 }}>Research Type</FormLabel></Col>
            <Col xs={12} sm={7} style={{ marginTop: 8, marginBottom: 4 }}>
              <Select
                className="basic-single"
                classNamePrefix="select"
                onChange={({ value }) => this.setState({ data: { ...data, researchType: value } })}
                defaultValue={researchType ? { label: researchType, value: researchType } : undefined}
                name="role"
                options={[
                  { label: "Alpine Macro", value: "Alpine Macro" },
                  { label: "Commodities", value: "Commodities" },
                  { label: "Global economics", value: "Global economics" },
                  { label: "Geopolitical analysis", value: "Geopolitical analysis" },
                  { label: "Thailand economics", value: "Thailand economics" },
                ]}
                isDisabled={loading}
              />
            </Col>
          </Row>

          {/* Author */}
          <Row>
            <Col xs={12} sm={4}><FormLabel style={{ marginTop: 6 }}>Author</FormLabel></Col>
            <Col xs={12} sm={7}>
              <FormControl
                type="text"
                name="author"
                placeholder="Author"
                style={{ marginTop: 5 }}
                value={author || ""}
                onChange={(e) => this.setState({ data: { ...data, author: e.target.value } })}
                disabled={loading}
              />
            </Col>
          </Row>
        </Modal.Body>

        {/* Footer */}
        <Modal.Footer>
          <Button bsStyle="success"
            loading={loading}
            onClick={() => this.onModalConfirm()}
            disabled={
              loading ||
              !date ||
              !title?.trim() ||
              !researchType?.trim() ||
              !author?.trim() ||
              (!id && !file)
            }>
            {this.state.loading ? 'Please wait' : 'Save'}
          </Button>
          <Button bsStyle="default"
            onClick={() => onClose(false)}
            disabled={loading}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}
